import request from './request';

// 获取所有知识类型
export function getKnowledgeTypes() {
  return request({
    url: '/knowledge-types',
    method: 'get'
  });
}

// 获取知识类型详情
export function getKnowledgeTypeById(id) {
  return request({
    url: `/knowledge-types/${id}`,
    method: 'get'
  });
}

// 创建知识类型
export function createKnowledgeType(data) {
  return request({
    url: '/knowledge-types',
    method: 'post',
    data
  });
}

// 更新知识类型
export function updateKnowledgeType(id, data) {
  return request({
    url: `/knowledge-types/${id}`,
    method: 'put',
    data
  });
}

// 删除知识类型
export function deleteKnowledgeType(id) {
  return request({
    url: `/knowledge-types/${id}`,
    method: 'delete'
  });
}

